export const NilObjectID = "000000000000000000000000"

export function isNilObjectID(oid: string|undefined|null): boolean {
    if(!oid) return true

    if(oid.trim().length == 0){
        return true
    }
    return oid === NilObjectID
}